import {http} from '@/http/index.js';

async function verificationsLast(girlId) {
  return http
    .get(`/girls/${girlId}/verifications/last`)
    .then((response) => response.data);
}

export {verificationsLast};
